// --- Firebase Configuration & Initialization ---
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// --- API Configuration ---
export const API_CONFIG = {
  url: 'https://whatsapp.bu-so.com/api/v1.php?table=flow_responses&action=list&q=(flow_token~equals~828927453101054)&records=10000',
  token: '4ad2c677-52fe-11ef-aafa-32d596423279'
} as const;

// --- Firebase Configuration (Pickleball S3) ---
export const firebaseConfig = {
  apiKey: "AIzaSyD3tuNemwOcGxc5O1DYWf_npRM6HW3aXnA",
  authDomain: "pickleballs3.firebaseapp.com",
  projectId: "pickleballs3",
  storageBucket: "pickleballs3.firebasestorage.app",
  messagingSenderId: "1076498908200",
  appId: "1:1076498908200:web:c229c69e3e28a8cd05211d",
  measurementId: "G-Z9XKS3ZSMY"
};

// --- Initialize Firebase ---
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

// --- Constants ---
export const APP_ID = 'mpl-season-3';
